import promptMatchesCollection from "../promptMatchesCollection";

const promptIsCustom = (prompt) => {
  return Boolean(prompt.teacher);
};

const promptIsCopied = (prompt) => {
  return Boolean(prompt.copiedAssignmentCreator);
};

const sortPromptsByDate = (prompts) => {
  if (!prompts) return [];

  return prompts.sort((a, b) => {
    return new Date(b.date_modified) - new Date(a.date_modified);
  });
};

const pickApplicableWritePrompt = ({
  prompts,
  collection,
  promptId,
  copiedAssignmentId,
}) => {
  const sortedPrompts = sortPromptsByDate(prompts);
  // 1. If the promptId is passed, attempt to return the prompt with that matching id.
  const promptMatchingId = sortedPrompts.find((prompt) => {
    return prompt.id.toString() === promptId;
  });
  if (promptMatchingId) return promptMatchingId;

  // 2. If copiedAssignmentId is passed, return the custom prompt from the copied assignment creator if exists
  if (copiedAssignmentId) {
    const customPromptMatchingCopiedAssignment = sortedPrompts.find(
      (prompt) => {
        return (
          promptIsCustom(prompt) &&
          promptIsCopied(prompt) &&
          promptMatchesCollection(prompt, collection)
        );
      },
    );
    if (customPromptMatchingCopiedAssignment)
      return customPromptMatchingCopiedAssignment;
  }

  // 3. If one exists, find the most recent custom prompt matching the selected collection.
  const customPromptMatchingCollection = sortedPrompts.find((prompt) => {
    return (
      promptIsCustom(prompt) && promptMatchesCollection(prompt, collection)
    );
  });
  if (customPromptMatchingCollection) return customPromptMatchingCollection;

  // 4. If one exists, find the most recent custom prompt with no collections.
  const customPromptWithNoCollections = sortedPrompts.find((prompt) => {
    return promptIsCustom(prompt) && !prompt?.collections?.length;
  });
  if (customPromptWithNoCollections) return customPromptWithNoCollections;

  // 5. Return the default write prompt
  const defaultPrompt = sortedPrompts.find((prompt) => {
    return (
      !promptIsCustom(prompt) &&
      (prompt.is_default_prompt || promptMatchesCollection(prompt, collection))
    );
  });
  if (defaultPrompt) return defaultPrompt;
};

export default pickApplicableWritePrompt;
